import axios from "axios";

export const API = axios.create({
  baseURL: "https://ragscoin2-0admin-api.skyapi.store/",
//  baseURL: "http://localhost:1014/",
});
